export default __webpack_public_path__ + "static/media/button-icon-delete.43bb7d9c.svg";